import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { select, Store } from '@ngrx/store';
import { AnalyticsSelectors } from 'app/main/analytics/selectors';
import { SnackbarOpen } from 'app/main/shared/snackbar/snackbar.actions';
import { AppState } from 'app/reducers';
import { AmplifyService } from 'aws-amplify-angular';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';

import { selectRuleError } from 'app/main/rule/rule.selectors';
import { CompanySubset } from 'app/api/company.api.service';
import { CompaniesSelectors, CompaniesUISelectors } from 'app/main/company/selectors';
import { selectCubeLoading } from 'app/main/cube/cube.selectors';

@Component({
    selector: 'provider',
    templateUrl: './provider.component.html',
    styleUrls: ['./provider.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class ProviderComponent implements OnInit, OnDestroy, AfterViewInit {
    public pageTitle;

    keyUp = new Subject<KeyboardEvent>();
    
    search$: Observable<string>;
    company$: Observable<CompanySubset>;
    loading$: Observable<boolean>;

    // Protected
    protected logger: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        protected amplifyService: AmplifyService,
        protected router: Router,
        protected activatedRoute: ActivatedRoute,
        protected store: Store<AppState>
    ) {
        this.logger = this.amplifyService.logger('ProviderComponent');
        this._unsubscribeAll = new Subject();
        this.pageTitle = activatedRoute.snapshot.data['title'];
    }

    ngOnInit(): void {
        this.loading$ = this.store.pipe(select(selectCubeLoading));
        // TODO: Implement a global service for Toasts (success & errors)
        this.store
            .pipe(
                takeUntil(this._unsubscribeAll),
                select(AnalyticsSelectors.selectAnalyticsError),
                filter(message => message !== null),
            )
            .subscribe(message => {
                this.store.dispatch(new SnackbarOpen({
                    message, action: 'OK', config: { panelClass: ['snackbar-error'] }
                }));
            });
        this.store
            .pipe(
                takeUntil(this._unsubscribeAll),
                select(selectRuleError),
                filter(message => message !== null),
            )
            .subscribe(message => {
                this.store.dispatch(new SnackbarOpen({
                    message, action: 'OK', config: { panelClass: ['snackbar-error'] }
                }));
            });

        this.search$ = this.keyUp
            .pipe(
                takeUntil(this._unsubscribeAll),
                map((event: any) => event.target.value || ''),
                debounceTime(250),
                distinctUntilChanged()
            );

        this.company$ = this.store
            .pipe(
                takeUntil(this._unsubscribeAll),
                select(CompaniesSelectors.selectCurrentCompany),
            );
        
        this.store
            .pipe(
                takeUntil(this._unsubscribeAll),
                select(CompaniesUISelectors.selectCurrentCompanyId),
            )
            .subscribe(companyId => {
                window.history.pushState({}, '', `/customers/${companyId}`);
            });
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
